<template>
    <div id="app">
        <keep-alive>
            <router-view v-if="$route.meta.keepAlive" :key="$route.fullPath"></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive" :key="$route.fullPath"></router-view>
    </div>
</template>

<script>
document.body.addEventListener('touchstart', function () {})
export default {
    name: 'App',
}
</script>


// WEBPACK FOOTER //
// src/App.vue